import { useState, useEffect } from "react"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { getCurrencyFormat } from "src/utils/string"

export function useCards(data) {
    const [infoCards, setInfo] = useState<any[]>([])
    const { formatCustomDate } = useFormatDate()

    const getInfoFormat = (data) => {
        const cards = [
            {
                title: "Unidades en inventario",
                value: data.unidades_inventario + data.unidad,
            },
            {
                title: "Producción por receta",
                value: data.produccion_receta + data.unidad,
            },
            {
                title: "Costo unitario promedio",
                value: getCurrencyFormat(data.costo_unitario_promedio),
            },
            {
                title: "Costo total de inventario",
                value: getCurrencyFormat(data.costo_total_inventario),
            },
            {
                title: "Última producción",
                value: formatCustomDate(data.fecha_ultima_produccion, "DD/MM/YYYY"),
            },
        ]

        return cards
    }

    useEffect(() => {
        if (data?.kpis_historial_producciones_inventarios)
            setInfo(getInfoFormat(data?.kpis_historial_producciones_inventarios || []))
    }, [data])

    return {
        infoCards,
    }
}
